<script lang="ts">
	import { clsx } from 'clsx';
	import Markdown from '$lib/components/generic/Markdown.svelte';

	import Button from '$lib/components/Button.svelte';
	import Container from '$lib/components/layout/Container.svelte';
	import { projects } from '$lib/stores';
</script>

<Container>
	<h1 class="sr-only">Projets</h1>
	<div class="space-y-14">
		{#each $projects.items as project, index (project.id)}
			<article class="flex flex-col">
				{#if project.subtitle}
					<div class="h5 uppercase border-b border-primary tracking-wide">{project.subtitle}</div>
				{/if}
				<div class="grid grid-cols-2 gap-9 mt-4">
					<div>
						<h2 class="h1">
							<Markdown content={project.title} />
						</h2>
						{#if project.date}
							<p class="font-serif italic text-3xl mt-4 font-light">{project.date}</p>
						{/if}
						<Button as="a" href={project.url} class="mt-4">Pour en savoir plus</Button>
					</div>
					<figure
						class={clsx('rounded-md mt-4 overflow-hidden w-full', {
							'-order-1': index % 2 == 1,
						})}
					>
						{#if project.cover}
							<img
								src={project.cover.sizes?.small?.url ?? project.cover.url}
								alt={project.cover.alt}
								width={project.cover.sizes?.small?.width ?? project.cover.width}
								height={project.cover.sizes?.small?.height ?? project.cover.height}
								class="w-full max-h-96 object-cover"
							/>
						{:else}
							<img src="/assets/img/photo-1634758661177-c053be669df6.jpg" alt="" />
						{/if}
					</figure>
				</div>
	
			</article>
		{/each}
	</div>
</Container>
